// extracted by mini-css-extract-plugin
module.exports = {"reduce-motion":"ReduceMotionToggle_reduce-motion__U6kiK","checked":"ReduceMotionToggle_checked__fLymb"};